import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Stack, IconButton } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const LikedProduct = ({ id, image, brand, name, price, originalPrice, onRemove, product }) => {
  const [isHovering, setIsHovering] = useState(false);
  const navigate = useNavigate();

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  };

  const handleClick = () => {
    navigate(`/product/${id}`, { state: { product } });
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    onRemove();
  };

  console.log(originalPrice)

  return (
    <Box 
      onClick={handleClick}
      sx={{ 
        display: 'flex', 
        gap: 2, 
        mb: 2, 
        width: '100%', 
        position: 'relative',
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.9
        }
      }}
    >
      <Box
        component="img"
        src={image}
        alt={name}
        sx={{
          width: 120,
          height: 160,
          objectFit: 'cover',
          borderRadius: 2,
        }}
      />
      <Stack spacing={1} sx={{ flex: 1 }}>
        <Typography variant="body3" sx={{ fontWeight: 600 }}>
          {brand}
        </Typography>
        <Typography variant="body4" color="text.secondary">
          {name}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {formatPrice(price)}
          </Typography>
          {originalPrice && originalPrice > price && (
            <Typography
              variant="body2"
              sx={{ textDecoration: 'line-through' }}
              color="text.secondary"
            >
              {formatPrice(originalPrice)}
            </Typography>
          )}
        </Box>
      </Stack>
      <IconButton 
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        size="small"
        sx={{ 
          alignSelf: 'center',
          color: 'text.secondary',
          zIndex: 100,
          '&:hover': {
            color: 'error.main',
          }
        }}
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default LikedProduct; 